import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bdfde8e2&scoped=true"
var script = {}
import style0 from "./index.vue?vue&type=style&index=0&id=bdfde8e2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfde8e2",
  null
  
)

export default component.exports